enum AgentMessageTypes {
  GetInitialDataRequest = -1,
  GetInitialDataResponse = -2,
  ReconnectedNotification = -3,
  RegisterClientRequestType = 1,
  RegisterClientResponseType = 3,
  CreateSessionRequestType = 4,
  CreateSessionResponseType = 5,
  AuthenticateSessionRequestType = 6,
  AuthenticateSessionResponseType = 7,
  GetProfileRequestType = 12,
  GetProfileResponseType = 13,
  AppPingRequestType = 103,
  AppPongResponseType = 104,
  MeshoutRequestType = 105,
  MeshoutResponseType = 106,
  GetOrganizationRequestType = 214,
  GetOrganizationResponseType = 215,
  ListHumanProxiesRequestType = 228,
  ListHumanProxiesResponseType = 229,
  LookupSiteInfoRequestType = 324,
  LookupSiteInfoResponseType = 325,
  MASpaceMessageNotificationType = 143,
  MeshOutNotification = 326,
  SpaceGetApplicationsRequestType = 378,
  SpaceGetApplicationsResponseType = 379,
  CheckMeshfaStatusRequestType = 439,
  CheckMeshfaStatusResponseType = 440,
}

export default AgentMessageTypes
